import { useTranslation } from 'react-i18next';

import * as SC from './SecuredByBadgeStyles';

import InnovatricsLogo from '@/assets/icons/innovatrics-logo.svg?react';

export const SecuredByBadge = () => {
  const { t } = useTranslation();

  return (
    <SC.Badge>
      <SC.BadgeText>{t('common.securedBadge')}</SC.BadgeText>
      <SC.BadgeLogoWrapper>
        <InnovatricsLogo />
      </SC.BadgeLogoWrapper>
    </SC.Badge>
  );
};
